import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { getInitials } from "@/lib/initials"
import type { User } from "@/types"

export function UserInfo({
  user,
  showEmail = false,
}: {
  user: User
  showEmail?: boolean
}) {
  return (
    <>
      <Avatar className="h-8 w-8 overflow-hidden rounded-full">
        <AvatarFallback
          className="rounded-lg bg-[var(--primary)] text-[var(--primary-foreground)]"
          style={{ boxShadow: "0 0 0 2px var(--border-heavy)" }}
        >
          {getInitials(user.name)}
        </AvatarFallback>
      </Avatar>
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium">{user.name}</span>
        {showEmail && (
          <span className="text-muted-foreground truncate text-xs">
            {user.email}
          </span>
        )}
      </div>
    </>
  )
}
